let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("kWrFZ"), load("h2MrD"), load("bYT2S"), load("cM9em"), load("fr9NE"), load("2QVAD")]).then(() => parcelRequire('456zR'));